// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4g-0";
export var eligibilityCardNotEligible = "_4g-1";